export interface FacebookPixel {
  id: string;
  name: string;
  code: string;
  isDataset?: boolean;
  business?: {
    id: string;
    name: string;
    profile_picture_uri?: string;
  };
}

export const exampleFacebookPixel = {
  name: 'Mock Pixel',
  code:
    '<!-- Facebook Pixel Code -->\n<script nonce="pNd3cJwT">\n!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?\nn.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;\nn.push=n;n.loaded=!0;n.version=\'2.0\';n.queue=[];t=b.createElement(e);t.async=!0;\nt.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,\ndocument,\'script\',\'https://connect.facebook.net/en_US/fbevents.js\');\n\nfbq(\'init\', \'123456789\');\nfbq(\'track\', "PageView");</script>\n<noscript><img height="1" width="1" style="display:none"\nsrc="https://www.facebook.com/tr?id=123456789&ev=PageView&noscript=1"\n/></noscript>\n<!-- End Facebook Pixel Code -->',
  id: '123456789',
};
